import { h } from "../kit/dom.ts";
import type { SkillBarView, SkillSlotView } from "./skill-bar-model.ts";

interface Cell {
  root: HTMLElement;
  name: HTMLElement;
  key: HTMLElement;
  time: HTMLElement;
  /** O que está no DOM (F109: compara campo a campo, sem montar uma chave por quadro). */
  shown: { title: string; name: string; key: string; time: string; cd: string; ready?: boolean; locked?: boolean };
}

/**
 * Barra de habilidades (F65): ao lado do cinto, a passiva, a ativa e a ultimate, cada uma com o nome, a
 * tecla e a recarga (`--cd`, de 0 a 1, pela CSS). Só mexe no DOM no que mudou.
 */
export class SkillBar {
  readonly element: HTMLElement;
  private readonly cells: Record<"passiva" | "ativa" | "ultimate", Cell>;

  constructor(parent: HTMLElement) {
    const cell = (slot: string): Cell => {
      const name = h("span", { class: "nome" });
      const key = h("span", { class: "tecla" });
      const time = h("span", { class: "tempo" });
      const root = h("div", { class: `habilidade ${slot}`, "data-habilidade": slot }, h("span", { class: "anel", "aria-hidden": "true" }), name, key, time);
      return { root, name, key, time, shown: { title: "", name: "", key: "", time: "", cd: "" } };
    };
    this.cells = { passiva: cell("passiva"), ativa: cell("ativa"), ultimate: cell("ultimate") };
    this.element = h("div", { id: "habilidades", "aria-label": "Habilidades" }, this.cells.passiva.root, this.cells.ativa.root, this.cells.ultimate.root);
    parent.appendChild(this.element);
  }

  update(view: SkillBarView): void {
    const paint = (cell: Cell, s: SkillSlotView) => {
      const shown = cell.shown;
      const title = `${s.name}: ${s.description}`;
      if (title !== shown.title) cell.root.title = shown.title = title;
      if (s.name !== shown.name) cell.name.textContent = shown.name = s.name;
      if (s.key !== shown.key) cell.key.textContent = shown.key = s.key;
      const time = s.seconds > 0 ? String(s.seconds) : "";
      if (time !== shown.time) cell.time.textContent = shown.time = time;
      const cd = s.cooldown.toFixed(3);
      if (cd !== shown.cd) cell.root.style.setProperty("--cd", (shown.cd = cd));
      if (s.ready !== shown.ready) cell.root.classList.toggle("pronta", (shown.ready = s.ready));
      if (s.locked !== shown.locked) cell.root.classList.toggle("bloqueada", (shown.locked = s.locked));
    };
    paint(this.cells.passiva, view.passiva);
    paint(this.cells.ativa, view.ativa);
    paint(this.cells.ultimate, view.ultimate);
  }

  /** Recusada (recarga, sem carga): um tremor curto na célula. */
  refuse(slot: "ativa" | "ultimate"): void {
    const root = this.cells[slot].root;
    root.classList.remove("recusa");
    void root.offsetWidth;
    root.classList.add("recusa");
  }
}
